import { tail } from "lodash";
import { action, observable } from "mobx";

export class ToastStore {
    @observable messages: string[] = [];

    @action addMessage(message: string) {
        this.messages = this.messages.concat(message);

        setTimeout(() => {
            this.messages = tail(this.messages);
        }, 3000);
    }
}

const toastSore = new ToastStore();
export default toastSore;


// WEBPACK FOOTER //
// ./src/stores/ToastStore.ts